// extracted by mini-css-extract-plugin
export default {"rotate":"PostPatchScanNotifier_rotate__vcmQn","spin":"PostPatchScanNotifier_spin__Tr-rL"};